import { useCallback, useRef, useState } from "react";

export function UploadDropzone({ onFiles, disabled }: { onFiles: (files: File[]) => void; disabled?: boolean }) {
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFiles = useCallback(
    (fileList: FileList | null) => {
      if (!fileList || fileList.length === 0) return;
      onFiles(Array.from(fileList));
    },
    [onFiles],
  );

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        if (!disabled) handleFiles(e.dataTransfer.files);
      }}
      onClick={() => !disabled && inputRef.current?.click()}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") inputRef.current?.click();
      }}
      aria-disabled={disabled}
      className={`flex cursor-pointer flex-col items-center justify-center gap-3 rounded-xl border-2 border-dashed p-10 text-center transition ${
        dragOver
          ? "border-brand-500 bg-brand-50 dark:bg-brand-950"
          : "border-slate-300 bg-white hover:border-brand-400 dark:border-night-700 dark:bg-night-900"
      } ${disabled ? "pointer-events-none opacity-60" : ""}`}
    >
      <span className="text-4xl" aria-hidden>
        ⬆️
      </span>
      <div>
        <p className="font-medium text-slate-700 dark:text-night-200">Drop ride CSVs here, or click to browse</p>
        <p className="mt-1 text-sm text-slate-500 dark:text-night-400">Accepts one or more .csv recordings from the companion app</p>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept=".csv,text/csv"
        multiple
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
        disabled={disabled}
      />
    </div>
  );
}
